import { render, staticRenderFns } from "./TravelData.vue?vue&type=template&id=6cf30604&scoped=true&"
import script from "./TravelData.vue?vue&type=script&lang=js&"
export * from "./TravelData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf30604",
  null
  
)

export default component.exports